import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import FeedbackForm from './components/FeedbackForm';
import { usePageMeta } from '@/hooks/usePageMeta';

const highlights = [
  {
    icon: 'ri-folder-open-line',
    title: '系统化整理',
    desc: '按电影、电视剧、纪录片、综艺分类收录，配合地区、年份、类型多维标签，方便快速定位内容。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '高效检索',
    desc: '支持关键词搜索与多维筛选，覆盖作品名称、导演、主演、类型等信息，几秒内找到想看的资源。',
  },
  {
    icon: 'ri-sparkling-2-line',
    title: '相关推荐',
    desc: '根据内容分类为你推荐相似作品，拓展观影选择，发现更多优质的国语对白影音内容。',
  },
];

const notices = [
  '本站内容以条目信息形式展示，供用户查询与浏览参考，不提供任何形式的影音文件存储与下载服务。',
  '站内所有资源信息、评分与浏览数据均为前端演示数据，用于展示页面逻辑与交互效果。',
  '收藏功能仅保存在当前浏览器本地存储中，不会上传到服务器，也不涉及任何账户体系。',
  '如内容信息存在偏差或有侵权疑虑，请通过本页反馈表单与我们联系，我们将及时核实处理。',
  '请在遵守当地法律法规的前提下使用本站，本站不承担因用户不当使用而产生的任何责任。',
];

export default function About() {
  usePageMeta(
    '关于我们 - 国语对白做受69高清影音资源集锦',
    '了解国语对白做受69网站定位与内容宗旨，通过反馈表单联系我们，查看使用须知与版权声明。',
    '关于国语对白做受69,联系我们,意见反馈,使用须知,版权声明'
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <Navbar />
      <main className="mx-auto w-full max-w-[1360px] flex-1 px-4 py-8 md:px-8 md:py-10">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />

        <section className="mt-5 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="p-7 md:p-10">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-label text-secondary-900">
              <i className="ri-information-line" />
              关于本站
            </span>
            <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于「国语对白做受69」
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-700 md:text-base">
              「国语对白做受69」是一个专注于国语对白高清影音资源的综合内容站。
              我们希望为喜爱国语影视作品的观众、研究者以及普通影迷，
              提供一个便捷的资源查询、浏览与了解渠道，
              让优质的国语对白影音内容更容易被发现和检索。
            </p>
            <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600">
              本站以现代门户式的内容组织方式呈现，围绕电影、电视剧、纪录片、综艺四大分类，
              结合关键词搜索、多维筛选与相关推荐，帮助用户在丰富的内容中高效地找到感兴趣的作品。
            </p>
          </div>
          <div className="grid grid-cols-1 gap-px border-t border-background-200 bg-background-200 sm:grid-cols-3">
            {highlights.map((item) => (
              <div key={item.title} className="bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.4fr]">
          <div className="flex flex-col gap-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h2 className="font-heading text-lg font-bold text-foreground-950">
                联系方式
              </h2>
              <ul className="mt-4 flex flex-col gap-4 text-sm">
                <li className="flex items-start gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className="ri-mail-line" />
                  </span>
                  <span>
                    <span className="block text-foreground-500">邮箱</span>
                    <span className="text-foreground-900">contact@gy69-media.example</span>
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className="ri-time-line" />
                  </span>
                  <span>
                    <span className="block text-foreground-500">响应时间</span>
                    <span className="text-foreground-900">工作日 1-3 个工作日内回复</span>
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className="ri-map-pin-line" />
                  </span>
                  <span>
                    <span className="block text-foreground-500">站点性质</span>
                    <span className="text-foreground-900">线上内容浏览与检索平台</span>
                  </span>
                </li>
              </ul>
            </div>

            <div className="rounded-lg border border-accent-300 bg-accent-100/60 p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-accent-900">
                <i className="ri-error-warning-line" />
                温馨提示
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-accent-900">
                本站为前端演示站点，搜索、筛选与收藏均为页面交互演示，
                反馈表单提交的信息将用于内容改进，我们会妥善处理你的联系方式。
              </p>
            </div>
          </div>

          <FeedbackForm />
        </section>

        <section className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-article-line text-primary-600" />
              使用须知
            </h2>
            <ul className="mt-4 flex flex-col gap-3">
              {notices.map((text) => (
                <li key={text} className="flex gap-2.5 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-primary-500" />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-copyright-line text-primary-600" />
              版权声明
            </h2>
            <div className="mt-4 flex flex-col gap-3 text-sm leading-relaxed text-foreground-700">
              <p>
                本站收录资源的名称、简介等信息均来源于公开资料整理，仅用于信息展示与检索，
                相关著作权归原作者及相关权利人所有。
              </p>
              <p>
                本站不生产、不存储、不传播任何影音文件，站内所有封面图片均为示意素材，
                与具体作品无直接关联。
              </p>
              <p>
                若权利人认为本站内容侵犯其合法权益，请通过本页反馈表单提交说明及相关证明，
                我们将在核实后第一时间处理。
              </p>
              <p className="text-foreground-500">
                © {new Date().getFullYear()} 国语对白做受69 高清影音资源集锦 · 保留所有权利。
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}